import * as React from 'react';
import {Button, Modal} from "react-bootstrap";
import { restartPlayer } from '../actions/playerActions';
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

const SmallModal = (props) => {
    const restartData = useSelector((state) =>  state.playerRestart);
    const {loading} = restartData;
    const [buttonLoading, setButtonLoading] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        if(loading){
            console.log('loading');
            setButtonLoading(true);
            simulateNetworkRequest().then(()=> {
                    props.onHide();
                    setButtonLoading(false);
                }
            )
        }
        else {
            console.log('not loading');
        }

    }, [loading]);

    function simulateNetworkRequest() {
        return new Promise((resolve) => setTimeout(resolve, 1500));
    }

    return (
        <Modal
            {...props}
            aria-labelledby="example-modal-sizes-title-sm"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-sm">
                    {props.t('card_restart')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={'text-black font-weight-bolder'}>{props.t('card_restart_confirm')}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>{props.t('card_cancel_button')}</Button>
                <Button variant="primary" disabled={buttonLoading} onClick={() => {
                    dispatch(restartPlayer(props.folder))
                }}>{buttonLoading? (props.t('card_restart_progress')) : (props.t('card_restart_button'))}</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SmallModal;
